import { useSearchParams } from 'react-router';
import { BottomNav } from '../components/ui';
import { IB, Kick, Screen, Seg, Sp, Top } from '../components/p';
import { CreateButton } from '../components/nav';
import { OrdersView } from './Orders';
import { MenusView } from './MenuScreens';

/** The Menus tab (P05 / P11): one-off orders by day, and the Menus customers order from. */
export function Menus() {
  // The view stays in the address, so coming back from a Menu lands on Menus.
  const [params, setParams] = useSearchParams();
  const view = params.get('view') === 'menus' ? 'menus' : 'orders';
  const setView = (v: 'orders' | 'menus') => setParams((p) => { const n = new URLSearchParams(p); if (v === 'menus') n.set('view', 'menus'); else n.delete('view'); n.delete('day'); return n; }, { replace: true });
  return (
    <>
      <Screen gap={16}>
        <Top>
          <div className="p-stack"><Kick>{view === 'orders' ? new Date().toLocaleDateString('en-IN', { weekday: 'long', day: 'numeric', month: 'long' }) : 'Your Menus'}</Kick><h1 className="p-h1">{view === 'orders' ? 'Orders' : 'Menus'}</h1></div>
          <Sp />
          <IB icon="search" label="Search" to="/search" />
        </Top>
        <Seg label="Orders or Menus" value={view} onChange={setView} options={[{ value: 'orders', label: 'Orders' }, { value: 'menus', label: 'Menus' }]} />
        {view === 'orders'
          ? <OrdersView />
          : <MenusView />}
      </Screen>
      {view === 'orders' ? <CreateButton to="/orders/new" label="New order" /> : <CreateButton to="/menus/new" label="New Menu" />}
      <BottomNav />
    </>
  );
}
